import React from 'react';

import AtlaskitButton from '@qality/common-components/src/atoms/atlaskit/Button';
import type { ButtonProps as AtlaskitButtonProps } from '@qality/common-components/src/atoms/atlaskit/Button';

import { ButtonWrapperStyled } from './Button.styled';

export interface ButtonProps {
  shouldFitContainer?: boolean;
  textLeft?: boolean;
  fontSize?: 'xsmall' | 'small' | 'medium';
  marginSize?: 'small' | 'medium';
  ml?: boolean;
  mr?: boolean;
  mb?: boolean;
  mt?: boolean;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLElement>;
}

export const Button: React.FC<ButtonProps & AtlaskitButtonProps> = ({
  textLeft,
  fontSize,
  marginSize,
  ml,
  mr,
  mb,
  mt,
  children,
  shouldFitContainer,
  ...buttonProps
}: ButtonProps) => {
  return (
    <ButtonWrapperStyled
      shouldFitContainer={shouldFitContainer}
      fontSize={fontSize}
      textLeft={textLeft}
      marginSize={marginSize}
      ml={ml}
      mr={mr}
      mb={mb}
      mt={mt}
    >
      <AtlaskitButton shouldFitContainer={shouldFitContainer} {...buttonProps}>
        {children}
      </AtlaskitButton>
    </ButtonWrapperStyled>
  );
};
